// Generated by CoffeeScript 1.11.1
(function() {
  var Descriptor, LayerInfo, UnicodePath,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  Descriptor = require('../descriptor');

  module.exports = UnicodePath = (function(superClass) {
    extend(UnicodePath, superClass);

    function UnicodePath() {
      return UnicodePath.__super__.constructor.apply(this, arguments);
    }

    UnicodePath.shouldParse = function(key) {
      return key === 'pths';
    };

    UnicodePath.prototype.parse = function() {
      this.file.seek(4);
      this.data = new Descriptor(this.file).parse();
      return this;
    };

    return UnicodePath;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/unicode_path.js
// module id = 77
// module chunks = 0